import { ProductSearchViewModel, ProductSearchViewModelGenericSearchResultViewModel } from '@models/api-search.models';
import { RelewiseRetailMediaPlacement } from '@core/services/relewise/relewise-tracking.model';

const relewiseRetailMediaId = 'RelewiseRetailMedia';
/**
 * This will process the retail media products and return the products for the given placement
 * So far the only placement we have is TOP since we want to keep the placement simple
 * and in top of the products and mark them as sponsored
 * @param filterResponse The filter response from the search service
 */
export const processRetailMediaProducts = (
    filterResponse?: ProductSearchViewModelGenericSearchResultViewModel
): ProductSearchViewModelGenericSearchResultViewModel => {
    if (!filterResponse?.retailMediaProducts) {
        return { ...filterResponse };
    }

    filterResponse.retailMediaProducts?.placements?.map(p => stampRetailMediaProducts(p.data));
    return { ...filterResponse };
};

/**
 * this will mark the products as retail media products, for that we use the active splashes property
 * We also need to create the match id (RelewiseMediaRetail) with the Umbraco Product Settings in order to get the text
 * And the type (retail-media) to use the correct implementation for the splash
 * @param products The products to mark as retail media products
 */
export const stampRetailMediaProducts = (products: ProductSearchViewModel[] = []): ProductSearchViewModel[] => {
    if (!products.length) {
        return products;
    }

    return products.map(product => {
        const alreadyStamped = product.activeSplashes?.some(splash => splash.id === relewiseRetailMediaId);

        if (!alreadyStamped) {
            product.activeSplashes?.push({
                id: relewiseRetailMediaId,
                type: 'RetailMedia',
                isPrimary: true
            });
        }

        return product;
    });
};

export const getRetailMediaProducts = (
    response: ProductSearchViewModelGenericSearchResultViewModel,
    placement: RelewiseRetailMediaPlacement = 'TOP'
): ProductSearchViewModel[] =>
    response.retailMediaProducts?.placements?.find(p => p.placementKey === placement)?.data ?? [];
